import { Component, inject } from '@angular/core';
import { ClientConfigService } from '../../../../services/client-config.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrl: './header.component.scss'
})
export class HeaderComponent {
  private clientConfigService = inject(ClientConfigService);

  get brokerId(): string {
    return this.clientConfigService.getBrokerId();
  }
}
